module.exports = __webpack_public_path__ + "img/pdf_03.27b43902.svg";